import { createContext, useState, useMemo, useContext, useCallback, useEffect } from 'react';

const ProductosContext = createContext();

const lineaLenta = process.env.REACT_APP_LINEA_LENTA === 'true';

export function ProductosProvider(props) {
    const tokenSessionObject = JSON.parse(sessionStorage.getItem('token'));
    const [selectedIndex, setSelectedIndex] = useState('');
    const [theProd, setTheProd] = useState({ piezasPorPaquete: '', paquetesPorTarima: '' });
    const [prodName, setProdName] = useState('');
    const [isSaveLines, setIsSaveLines] = useState(true);
    const [isSaveCap, setIsSaveCap] = useState(true);
    const [isProdSelected, setIsProdSelected] = useState(true);
    const [isLineSelected, setIsLineSelected] = useState(true);
    const [alerta, setAlerta] = useState('');
    const [abrir, setAbrir] = useState(false);
    const [selectedLine, setSelectedLine] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const [checked, setChecked] = useState([]);
    const [product, setProduct] = useState([]);
    const [lines, setLines] = useState([]);
    const [pzas, setPzas] = useState(0);
    const [ideal, setIdeal] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [std, setStd] = useState(0);
    const [editProduct, setEditProduct] = useState({
        eNombre: '',
        EPP: '',
        EPT: '',
        sku: '',
    });
    const [capacities, setCapacities] = useState([]);
    const [prodLine, setProdLine] = useState([]);
    const [actions, setActions] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);
    const [nuevo, setNuevo] = useState(false);
    const [editar, setEditar] = useState(false);
    const [borrar, setBorrar] = useState(false);
    const [snackbar, setSnackbar] = useState(false);
    const [msgSb, setMsgSb] = useState('Se guardó la información correctametne');
    const [severitySb, setSeveritySb] = useState('success');
    const [newProd, setNewProd] = useState({
        id: null,
        sku: '',
        nombre: '',
    });

    const clearLines = useCallback(() => {
        const newChecked = [...checked];
        newChecked.length = 0;
        setChecked(newChecked);
    }, [checked]);

    const loadLines = useCallback((array) => {
        const newChecked = [...checked];
        newChecked.length = 0;

        array.forEach((element) => {
            newChecked.push(element);
        });

        setChecked(newChecked);
        setIsSaveLines(true);
    }, [checked]);

    const getCapacities = useCallback(
        (sku) => {
            if (sku !== '') {
                fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/capacidades?sku=${sku}`, {
                    method: 'GET',
                    headers: {
                        authorization: `Bearer ${tokenSessionObject.token}`,
                        Accept: 'application/json',
                    },
                })
                    .then((res) => res.json())
                    .catch((error) => console.error('Error: ', error))
                    .then((response) => {
                        if (response != null) {
                            if (
                                response !==
                                'El producto especificado no existe o no tiene asignada una capacidad'
                            ) {
                                setCapacities(response); // Actualiza capacities
                            } else {
                                setPzas(0);
                                setIdeal(0);
                                setStd(0);
                            }
                        }
                    });
            }
        },
        [tokenSessionObject.token]
    );

    // Este useEffect se ejecutará cuando capacities cambie
    useEffect(() => {
        if (capacities) {
            // Aquí puedes realizar acciones adicionales con el valor actualizado de capacities
        }
    }, [capacities]);


    const getSelectedLines = useCallback((sku) => {
        if (sku !== '') {
            fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/productolinea/${sku}`, {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                },
            })
                .then((res) => res.json())
                .catch((error) => console.error('Error: ', error))
                .then((response) => {
                    const array = [];
                    if (
                        response != null &&
                        response !== 'Producto no encontrado o ha sido eliminado' &&
                        response !== 'Linea inexistente o no existen productos asignados'
                    ) {
                        response.forEach((item) => array.push(item.linea - 1));
                        loadLines(array);
                        setProdLine(array);
                    } else {
                        clearLines();
                    }
                });
        }
    }, [clearLines, loadLines, tokenSessionObject.token]);

    const handleListItemClick = useCallback((index) => {
        setSelectedIndex(index);
        getCapacities(index);
        getSelectedLines(index);
        setIsProdSelected(false);
        setSelectedLine(0);
        setIsLineSelected(true);
        setIsSaveCap(true);
        // setPzas(0);
        // setIdeal(0);
        // setStd(0);
    }, [getCapacities, getSelectedLines]);

    const isChecked = useCallback((index) => {
        const currentIndex = checked.indexOf(index);

        if (currentIndex !== -1) {
            setIsLineSelected(false);
        } else {
            setIsLineSelected(true);
        }
    }, [checked]);

    const showCapacities = useCallback((line) => {
        if (line !== '' && capacities.length > 0) {
            const capa = capacities.find((capacitie) => capacitie.linea === line);
            if (capa !== undefined) {
                setPzas(capa.piezasPorPaquete);
                setIdeal(lineaLenta && capa.ritmoIdeal > 0 ? Math.round(1 / capa.ritmoIdeal) : capa.ritmoIdeal);
                setStd(lineaLenta && capa.ritmoEstandar > 0 ? Math.round(1 / capa.ritmoEstandar) : capa.ritmoEstandar);
            } else {
                setPzas(0);
                setIdeal(0);
                setStd(0);
            }
        } else {
            setPzas(0);
            setIdeal(0);
            setStd(0);
        }
    }, [capacities]);

    const handleListLinesClick = useCallback((_event, index) => {
        setSelectedLine(index);
        // getCapacities(selectedIndex);
        showCapacities(index);
        isChecked(index - 1);
    }, [isChecked, showCapacities]);

    const handleClick = (sku, name) => {
        //setAnchorEl(event.currentTarget);
        setSelectedIndex(sku);
        setProdName(name);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleToggle = useCallback((value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
        setIsSaveLines(false);
    }, [checked]);

    const handleinputChange = useCallback((event) => {
        setNewProd({
            ...newProd,
            [event.target.name]: event.target.value,
        });
    }, [newProd]);

    const getProducts = useCallback(async () => {
        const data = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/productos`, {
            method: 'GET',
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
            },
        });
        const products = await data.json();
        setProduct(products);
    }, [tokenSessionObject.token]);

    const getTheProduct = useCallback((sku) => {
        fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/productos/GetProductoSku?sku=${sku}`, {
            method: 'GET',
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
            },
        })
            .then((res) => res.json())
            .catch((error) => console.error('Error: ', error))
            .then((response) => {
                setProdName(response.nombre);
                setTheProd(response);
            });
    }, [tokenSessionObject.token]);

    const getLines = useCallback(async () => {
        const data = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/lineas`, {
            method: 'GET',
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
            },
        });
        const line = await data.json();

        setLines(line);
    }, [tokenSessionObject.token]);

    const cnlLines = useCallback((event) => {
        event.preventDefault();
        getSelectedLines(selectedIndex);
    }, [getSelectedLines, selectedIndex]);

    const cnlCap = useCallback((event) => {
        event.preventDefault();
        setIsSaveCap(true);
        showCapacities(selectedLine);
    }, [selectedLine, showCapacities]);

    const setNewProduct = useCallback(async (data) => {
        const res = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/Productos`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        });

        const respuesta = await res.text();

        if (res.status === 200) {
            getProducts();
            setMsgSb('Producto creado correctamente.');
            setSeveritySb('success');
            setSnackbar(true);
            setNuevo(false);
        } else {
            console.error(respuesta, res.status);
        }
    }, [getProducts, tokenSessionObject.token]);

    const setEditProd = useCallback((data) => {
        fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/productos/${data.sku}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then((res) => res.json())
            .catch((error) => console.error('Error: ', error))
            .then((response) => {
                getProducts();
                setMsgSb(response);
                setSeveritySb('success');
                setSnackbar(true);
                setSearchText('');
            });
    }, [getProducts, tokenSessionObject.token]);

    const delProd = useCallback(async () => {
        const resp = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT}/productos/Eliminar?sku=${editProduct.sku}`,
            {
                method: 'PUT',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                },
            }
        );
        const respuesta = await resp.json();
        if (resp.status === 200) {
            setMsgSb('Producto eliminado satisfactoriamente.');
            setSeveritySb('success');
            setSnackbar(true);
            getProducts();
        } else {
            setMsgSb(respuesta);
            setSeveritySb('error');
            setSnackbar(true);
            getProducts();
        }
    }, [editProduct.sku, getProducts, tokenSessionObject.token]);

    const saveLines = useCallback(async (event) => {
        event.preventDefault();
        const addLines = checked.filter((elemento) => prodLine.indexOf(elemento) === -1);
        const deleteLines = prodLine.filter((elemento) => checked.indexOf(elemento) === -1);
        if (addLines.length > 0) {
            let data;

            const postLines = await Promise.all(
                addLines.map(async (addline) => {
                    data = {
                        linea: addline + 1,
                        sku: editProduct.sku,
                    };

                    return await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/productolinea`, {
                        method: 'POST',
                        body: JSON.stringify(data),
                        headers: {
                            authorization: `Bearer ${tokenSessionObject.token}`,
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                    });
                })
            );

            let cont = 0;

            postLines.forEach((postLine) => {
                if (postLine.status === 201 || postLine.status === 204) {
                    cont++;
                }
            });

            if (cont === postLines.length) {
                setMsgSb('Se guardó la información correctamente');
                setSeveritySb('success');
                setSnackbar(true);
            }
        }
        if (deleteLines.length > 0) {
            let data1;
            const delLines = await Promise.all(
                deleteLines.map(async (deleteLine) => {
                    data1 = {
                        linea: deleteLine + 1,
                        sku: editProduct.sku,
                    };

                    return await fetch(
                        `${process.env.REACT_APP_SERVICE_ENDPOINT}/productolinea/eliminar`,
                        {
                            method: 'PUT',
                            body: JSON.stringify(data1),
                            headers: {
                                authorization: `Bearer ${tokenSessionObject.token}`,
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                            },
                        }
                    );
                })
            );
            let cont1 = 0;

            delLines.forEach((delLine) => {
                if (delLine.status === 201 || delLine.status === 204) {
                    cont1++;
                }
            });
            if (cont1 === delLines.length) {
                setMsgSb('Se guardó la información correctamente');
                setSeveritySb('success');
                setSnackbar(true);
            }
        }
        getSelectedLines(editProduct.sku);
    }, [checked, editProduct.sku, getSelectedLines, prodLine, tokenSessionObject.token]);

    const saveCapacities = useCallback((event) => {
        event.preventDefault();
        let flag = true;
        //Buscamos la informacion de la capacidad
        capacities.forEach((capacity) => {
            if (capacity.linea === selectedLine && capacity.sku === selectedIndex && flag) {
                flag = false;
                const data = {
                    linea: capacity.linea,
                    sku: capacity.sku,
                    esDeLinea: capacity.esDeLinea,
                    piezasPorPaquete: pzas,
                    ritmoIdeal: lineaLenta && ideal > 0 ? 1 / ideal : ideal,
                    ritmoEstandar: lineaLenta && std > 0 ? 1 / std : std,
                };
                fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/capacidades`, {
                    method: 'PUT',
                    body: JSON.stringify(data),
                    headers: {
                        authorization: `Bearer ${tokenSessionObject.token}`,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                })
                    .then((res) => res.json())
                    .catch((error) => console.error('Error: ', error))
                    .then((response) => {
                        if (response !== undefined) setMsgSb(response);
                        else setMsgSb('Se guardó la información correctamente');
                        setSeveritySb('success');
                        setSnackbar(true);
                        setIsSaveCap(true);
                    });
            }
        });
        if (flag) {
            const data = {
                linea: selectedLine,
                sku: selectedIndex,
                esDeLinea: true,
                piezasPorPaquete: pzas,
                ritmoIdeal: lineaLenta && ideal > 0 ? 1 / ideal : ideal,
                ritmoEstandar: lineaLenta && std > 0 ? 1 / std : std,
            };
            fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/capacidades`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
                .then((res) => res.json())
                .catch((error) => console.error('Error: ', error))
                .then((response) => {
                    if (response !== undefined) setMsgSb(response);
                    else setMsgSb('Se guardó la información correctamente');
                    setSeveritySb('success');
                    setSnackbar(true);
                    setIsSaveCap(true);
                });
        }
    }, [capacities, ideal, pzas, selectedIndex, selectedLine, std, tokenSessionObject.token]);

    const postNewProd = useCallback((event) => {
        event.preventDefault();
        setNewProduct(newProd);
    }, [newProd, setNewProduct]);


    const putProd = useCallback((event) => {
        event.preventDefault();
        const prodEd = {
            id: editProduct.sku,
            nombre: editProduct.eNombre,
            sku: editProduct.sku,
            piezasPorPaquete: editProduct.EPP,
            paquetesPorTarima: editProduct.EPT,
        };
        setEditar(false);
        setEditProd(prodEd);
    }, [editProduct.EPP, editProduct.EPT, editProduct.eNombre, editProduct.sku, setEditProd]);

    // function sleep(ms) {
    //     return new Promise((resolve) => setTimeout(resolve, ms));
    // }
    // const dataTable = async () => {
    //     await sleep(3500);
    //     getProducts();
    // };

    const increment = useCallback((event, field) => {
        event.preventDefault();
        setIsSaveCap(false);
        switch (field) {
            case 0:
                setPzas(pzas + 1);
                break;
            case 1:
                setIdeal(ideal + 1);
                break;
            case 2:
                setStd(std + 1);
                break;
            default:
                break;
        }
    }, [ideal, pzas, std]);

    const decrement = useCallback((event, field) => {
        event.preventDefault();
        setIsSaveCap(false);
        switch (field) {
            case 0:
                if (pzas !== 0) {
                    setPzas(pzas - 1);
                }
                break;
            case 1:
                if (ideal !== 0) {
                    setIdeal(ideal - 1);
                }
                break;
            case 2:
                if (std !== 0) {
                    setStd(std - 1);
                }
                break;
            default:
                break;
        }
    }, [ideal, pzas, std]);

    const setCapValue = useCallback((field, value) => {
        const num = Math.max(0, parseInt(value) || 0);
        setIsSaveCap(false);
        switch (field) {
            case 0: setPzas(num); break;
            case 1: setIdeal(num); break;
            case 2: setStd(num); break;
            default: break;
        }
    }, []);

    const productosValues = useMemo(() => {
        return {
            selectedIndex,
            setSelectedIndex,
            theProd,
            prodName,
            setProdName,
            getTheProduct,
            isSaveLines,
            setIsSaveLines,
            isSaveCap,
            setIsSaveCap,
            actions,
            setActions,
            isProdSelected,
            setIsProdSelected,
            isLineSelected,
            setIsLineSelected,
            alerta,
            setAlerta,
            abrir,
            setAbrir,
            selectedLine,
            setSelectedLine,
            anchorEl,
            setAnchorEl,
            checked,
            setChecked,
            product,
            setProduct,
            lines,
            setLines,
            pzas,
            setPzas,
            ideal,
            setIdeal,
            std,
            setStd,
            getProducts,
            capacities,
            setCapacities,
            prodLine,
            setProdLine,
            newProd,
            setNewProd,
            handleListItemClick,
            handleListLinesClick,
            handleClick,
            handleClose,
            handleToggle,
            handleinputChange,
            getLines,
            cnlLines,
            cnlCap,
            saveLines,
            msgSb,
            setMsgSb,
            saveCapacities,
            postNewProd,
            putProd,

            increment,
            decrement,
            setCapValue,
            snackbar,
            setSnackbar,
            severitySb,
            setSeveritySb,
            selectionModel,
            setSelectionModel,
            nuevo,
            setNuevo,
            editar,
            setEditar,
            borrar,
            setBorrar,
            editProduct,
            setEditProduct,
            searchText,
            setSearchText,
            delProd,
        };
    }, [selectedIndex, theProd, prodName, getTheProduct, isSaveLines, isSaveCap, actions, isProdSelected, isLineSelected, alerta, abrir, selectedLine, anchorEl, checked, product, lines, pzas, ideal, std, getProducts, capacities, prodLine, newProd, handleListItemClick, handleListLinesClick, handleToggle, handleinputChange, getLines, cnlLines, cnlCap, saveLines, msgSb, saveCapacities, postNewProd, putProd, increment, decrement, setCapValue, snackbar, severitySb, selectionModel, nuevo, editar, borrar, editProduct, searchText, delProd]);

    return <ProductosContext.Provider value={productosValues} {...props} />;
}

export function useProductos() {
    const context = useContext(ProductosContext);
    if (!context) throw new Error('useProductos debe estar dentro del proveedor ProductosContext');
    return context;
}
